module.exports = __webpack_public_path__ + "static/010.thumb-33cc61ea1b0a7bb14a3c09f2aef7fa41.jpg";